export const APPCUES_ID = {
    SWITCH_BUTTON: 'SWITCH_BUTTON',
};
